<template>
    <div id="header_logo_component"
         class="header-logo-component">
        <router-link :to="'/'" class="header-logo--inner" v-if="hasPacket">
            <img src="../../../../../assets/img/futuronetwork-logo.png" alt="FuturoNetwork">
        </router-link>
        <span class="header-logo--inner" v-else>
            <img src="../../../../../assets/img/futuronetwork-logo.png" alt="FuturoNetwork">
        </span>
    </div>
</template>
<script>
    export default {
        computed: {
            hasPacket () {
                return this.$store.getters.user.position != 0
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/header/middlebar/HeaderLogo.vue